var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{staticClass:"ametras-treeview",class:_vm.themeClassName,attrs:{"value":_vm.localValue,"group":_vm.group,"ghost-class":"ghost"},on:{"input":_vm.updateValue}},_vm._l((_vm.localValue),function(item){return _c('draggable-tree-view-node',{key:item.id,attrs:{"group":_vm.group,"value":item,"selectedItem":_vm.selectedItem,"level":0},on:{"input":_vm.updateItem,"selected":_vm.updateSelectedItem,"childmoveup":_vm.onChildMoveUp,"childmovedown":_vm.onChildMoveDown,"childdelete":_vm.onChildDelete},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
var open = ref.open;
var hover = ref.hover;
var selected = ref.selected;
var deleteItem = ref.deleteItem;
var moveUp = ref.moveUp;
var moveDown = ref.moveDown;
return [_vm._t("prepend",null,null,{ item: item, open: open, hover: hover, selected: selected, deleteItem: deleteItem, moveUp: moveUp, moveDown: moveDown })]}},{key:"label",fn:function(ref){
var item = ref.item;
var open = ref.open;
var hover = ref.hover;
var selected = ref.selected;
var deleteItem = ref.deleteItem;
var moveUp = ref.moveUp;
var moveDown = ref.moveDown;
return [_vm._t("label",null,null,{ item: item, open: open, hover: hover, selected: selected, deleteItem: deleteItem, moveUp: moveUp, moveDown: moveDown })]}},{key:"append",fn:function(ref){
var item = ref.item;
var open = ref.open;
var hover = ref.hover;
var selected = ref.selected;
var deleteItem = ref.deleteItem;
var moveUp = ref.moveUp;
var moveDown = ref.moveDown;
return [_vm._t("append",null,null,{ item: item, open: open, hover: hover, selected: selected, deleteItem: deleteItem, moveUp: moveUp, moveDown: moveDown })]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }